// extracted by mini-css-extract-plugin
module.exports = {"headerActions":"RegionMasterPage_headerActions__352En"};